import type { SupportedMarketKey } from '@nxt-insurance/constants'

import type { OptionValue } from '@ui-kit/components/formComponents/Select/types'

import type { Country } from './types'

/*
    TODO Those functions should be covered by tests
    Ticket: https://hellogetsafe.atlassian.net/browse/BX-713
 */
export const displaySelectedOption = (countries: Country[], option?: OptionValue) => {
  const country = getCountryByCode(countries, option)
  return country ? `${country.flag} ${country.dial_code}` : ''
}

export const getCountryByCode = (countries: Country[], option?: OptionValue) =>
  countries.find((c) => c.code === option)

export const getOptions = (currentMarket: SupportedMarketKey, countries: Country[]) => {
  const defaultCountry = getDefaultCountry(countries, currentMarket)
  return countries
    .sort((countryA: Country, countryB: Country) => {
      const nameA = countryA.label
      const codeA = countryA.code
      const nameB = countryB.label
      const codeB = countryB.code
      const defaultCode = defaultCountry?.code ?? ''

      if ([codeA, codeB].includes(defaultCode)) {
        if (codeA === defaultCode) {
          return -1
        }
        if (codeB === defaultCode) {
          return 1
        }
        return 0
      }

      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
    .map((country) => {
      return {
        label: `${country.flag} ${country.label} (${country.dial_code})`,
        value: country.code,
      }
    })
}

export const getDefaultCountry = (countries: Country[], currentMarket: SupportedMarketKey) => {
  return countries.find((country) => country.code === currentMarket.toUpperCase())
}

export const getDialCodeFromCountryCode = (
  countries: Country[],
  code?: string
): Country['dial_code'] | undefined => {
  if (code === undefined) {
    return undefined
  }
  const country = countries.find((c) => c.code === code)
  return country?.dial_code
}
